'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EventList = require('./EventList');

var _EventList2 = _interopRequireDefault(_EventList);

var _EventListItem = require('./EventListItem');

var _EventListItem2 = _interopRequireDefault(_EventListItem);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Popover = require('./Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MapMarker = function (_Component) {
  _inherits(MapMarker, _Component);

  function MapMarker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MapMarker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MapMarker.__proto__ || Object.getPrototypeOf(MapMarker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoverVisible: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MapMarker, [{
    key: 'setPopoverVisibility',
    value: function setPopoverVisibility(status) {
      this.setState({ popoverVisible: status });
    }
  }, {
    key: 'showPopover',
    value: function showPopover() {
      if (!this.state.popoverVisible) {
        this.setPopoverVisibility(true);
      }
    }
  }, {
    key: 'hidePopover',
    value: function hidePopover() {
      if (this.state.popoverVisible) {
        this.setPopoverVisibility(false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.id || this.props.events.length // eslint-disable-line react/prop-types
      ? _react2.default.createElement(
        'span',
        {
          onMouseEnter: this.showPopover.bind(this),
          onMouseLeave: this.hidePopover.bind(this),
          onClick: this.showPopover.bind(this),
          onKeyPress: (0, _utils.handleKeyPress)(this.showPopover.bind(this)),
          className: 'MapMarker interactive'
        },
        _react2.default.createElement(
          _Popover2.default,
          {
            visible: this.state.popoverVisible,
            clickOverlay: this.hidePopover.bind(this),
            width: 200,
            dropdownView: this.props.events.length ? _react2.default.createElement(_EventList2.default, { events: this.props.events, layout: 'grid', size: 'small', groupBy: 'none', columns: 1 }) : _react2.default.createElement(_EventListItem2.default, { layout: 'grid', size: 'small', event: this.props })
          },
          _react2.default.createElement(_Icon2.default, { name: 'pin' })
        )
      ) : _react2.default.createElement(
        'span',
        { className: 'MapMarker' },
        _react2.default.createElement(_Icon2.default, { name: 'pin' })
      );
    }
  }]);

  return MapMarker;
}(_react.Component);

MapMarker.propTypes = {
  /** Optional array to display more than one event at a time */
  events: _propTypes2.default.array
};
MapMarker.defaultProps = {
  events: []
};
exports.default = MapMarker;
MapMarker.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'setPopoverVisibility',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'status',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'showPopover',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'hidePopover',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'displayName': 'MapMarker',
  'props': {
    'events': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'array'
      },
      'required': false,
      'description': 'Optional array to display more than one event at a time'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/MapMarker.js
// module id = 188
// module chunks = 0